<template>
<!-- 公共日志弹窗 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="80%"
    @ok="handleCancel"
    @cancel="handleCancel"
    :footer="null"
  >
  <a-table ref="TableInfo"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="pagination"
                bordered
                :rowKey='record=>record.id'
               :loading="loading"
               @change="handleTableChange" :scroll="{ x: 1200, y: 482 }">
        <template slot="method" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <div>{{text}}</div>
            </template>
            <p style="width: 200px;margin-bottom: 0">{{text}}</p>
          </a-popover>
        </template>
        <template slot="params" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <div v-html="text" style="max-width: 800px;overflow: auto;" class="ql-editors"></div>
            </template>
            <div v-html="text" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis; margin-bottom: 0"  class="ql-editors"></div>
          </a-popover>
        </template>
      </a-table>
  </a-modal>
</template>

<script>
export default {
  name: 'PublicDialog',
  // components: {paymentScheduleAdd},
  props: {
    title: {
      type: String,
      default: '数据操作日志'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentName) {
        return (resolve) => require([`@/views/${this.componentName}`], resolve)
      }
      return null
    },
    columns () {
      let { sortedInfo } = this
      sortedInfo = sortedInfo || {}
      return [{
        title: '操作时间',
        dataIndex: 'createTime',
        sorter: true,
        width: 200,
        sortOrder: sortedInfo.columnKey === 'createTime' && sortedInfo.order
      }, {
        title: '操作人',
        dataIndex: 'username',
        width: 100
      }, {
        title: 'IP地址',
        dataIndex: 'ip',
        width: 150
      }, {
        title: '操作描述',
        ellipsis: true,
        width: 200,
        dataIndex: 'operation'
      }, {
        title: '修改内容',
        dataIndex: 'params',
        ellipsis: true,
        scopedSlots: { customRender: 'params' }
      }]
      // {
      //   title: '操作地点',
      //   dataIndex: 'location',
      //   width: 150
      // },
      // {
      //   title: '耗时',
      //   dataIndex: 'time',
      //   width: 80,
      //   customRender: (text, row, index) => {
      //     if (text < 500) {
      //       return <a-tag color="green">{text} ms</a-tag>
      //     } else if (text < 1000) {
      //       return <a-tag color="cyan">{text} ms</a-tag>
      //     } else if (text < 1500) {
      //       return <a-tag color="orange">{text} ms</a-tag>
      //     } else {
      //       return <a-tag color="red">{text} ms</a-tag>
      //     }
      //   },
      //   sorter: true,
      //   sortOrder: sortedInfo.columnKey === 'time' && sortedInfo.order
      // }, {
      //   title: '执行方法',
      //   dataIndex: 'method',
      //   ellipsis: true,
      //   width: 200,
      //   scopedSlots: { customRender: 'method' }
      // },
    }
  },
  data () {
    return {
      dataSource: [],
      sortedInfo: null,
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      selectedRowKeys: [],
      paginationInfo: null,
      loading: false
    }
  },
  mounted () {

  },
  methods: {
    handleTableChange (pagination, filters, sorter) {
      // 将这两个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination
      this.sortedInfo = sorter
      this.fetch({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
        ...this.dataForm
      })
    },
    getLog (params, path) {
      this.dataForm = params
      this.fetch(params)
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleSuccuse () {
      this.$emit('cancel')
    },
    fetch (params = {}) {
      this.loading = true
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('log', {
        ...params
      }).then((r) => {
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = Number(data.total)
        this.loading = false
        this.dataSource = data.rows
        this.pagination = pagination
      })
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .ant-modal {
    padding-bottom: 0;
    box-sizing: border-box;
    .ant-modal-content {
      min-height: auto !important;
      background-color: #fff;
      height: auto !important;
    }
  }
  .ql-editors {
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modelDialog/publicLogDialog.vue